/**
 * @fileoverview DELETE handler for the "/engagement/:app_group_id/whats_app/message_template/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys } from "./constants";

interface DeleteWhatsAppMessageTemplateDraftProps {
  appGroupId: string;
  id: string;
}

export const deleteWhatsAppMessageTemplateDraft = reactQueryMutationAdapter(
  engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys,
  ({ appGroupId, id }: DeleteWhatsAppMessageTemplateDraftProps): Promise<void> => {
    return fetch(`/engagement/${appGroupId}/whats_app/message_template/${id}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
